import { getQuestionMeta } from "../utils/questionMeta"
import { TQuestion } from "../../../api/type"

type QuestionMetaChipsProps = {
  question: TQuestion
  levelLabels?: string[]
}

const QuestionMetaChips = ({ question, levelLabels }: QuestionMetaChipsProps) => {
  const metaItems = getQuestionMeta(question, { levelLabels })

  if (metaItems.length === 0) return null

  return (
    <div className="question_meta">
      {metaItems.map((meta) => (
        <span
          className="question_meta__chip"
          key={`${question.id}-${meta.label}`}
        >
          <strong>{meta.label}:</strong> {meta.value}
        </span>
      ))}
    </div>
  )
}

export default QuestionMetaChips
